import React from 'react';
import Time from './Time';
import NoValue from '../EmptyStates/NoValue';

const ScheduleConstraints = ({ constraints, empty }) => {
    const _empty = empty ?? <NoValue />;

    if (constraints === null) {
        return _empty;
    }

    const parts = [];

    if ((constraints?.dayOfWeek ?? null) !== null) {
        parts.push(`On ${constraints.dayOfWeek}s`);
    }

    if ((constraints?.weekOfMonth ?? null) !== null) {
        const weekTitles = {
            '1': 'First',
            '2': 'Second',
            '3': 'Third',
            '4': 'Fourth',
            '5': 'Fifth',
        }
        if (parts.length) {
            parts.push(', ');
        }
        parts.push(`On the ${weekTitles[constraints.weekOfMonth]} week of the month`);
    }

    if ((constraints?.timeRange?.from ?? null) !== null || (constraints?.timeRange?.to ?? null) !== null) {
        if (parts.length) {
            parts.push(', ');
        }
        parts.push(<>
            Between <Time time={constraints.timeRange.from} /> and <Time time={constraints.timeRange.to} />
        </>);
    }

    if (parts.length) {
        return parts.map((p, i) => <React.Fragment key={i}>{p}</React.Fragment>);
    }

    return _empty;
}

export default ScheduleConstraints;